module.exports = __webpack_public_path__ + "img/stageSection02.d791e262.png";